import { PostHogFeatureFlagResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class GetAdminPostHogFeatureFlags
  extends BaseAdapter<PostHogFeatureFlagResponse[]>
  implements AdapterInterface {
  rawResponse: PostHogFeatureFlagResponse[];

  async adaptResponse(): Promise<PostHogFeatureFlagResponse[]> {
    await this.fetchApiResponse('/api/admin/filters/posthog-feature-flags', HTTPMethod.Get);
    return this.rawResponse;
  }
}
